import React from 'react'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { useLatestClientStatusReport } from '../../../../../api/groups'
import StatusReportSummaryBoardLayout from './components/StatusReportSummaryBoardLayout'

function ClientStatusReportSummaryDefaultLayout (props) {
  const { clientId } = useAppContext()
  const { data, isLoading } = useLatestClientStatusReport(clientId)

  return (
    <StatusReportSummaryBoardLayout
      {...props}
      report={data?.report}
      statuses={data?.statuses}
      loading={isLoading}
    />
  )
}

export default ClientStatusReportSummaryDefaultLayout
